import {
  CalendarMonth,
  FlightTakeoff,
  Inventory2,
  LocalOffer,
  LocalShipping,
  Lock,
  People,
  ShoppingBasket,
  ShoppingCart
} from '@mui/icons-material'

import { AdminNavigationItem } from './AdminDashboard.types'

export const adminNavigationPaths = {
  users: 'users',
  externalBookings: 'external-bookings',
  offerRequests: 'offer-requests',
  fulfillmentOrders: 'fulfillment-orders',
  readyToPurchase: 'ready-to-purchase',
  trips: 'trips',
  discountCodes: 'discount-codes',
  lockers: 'lockers',
  lockerOrders: 'locker-orders'
}

export const adminNavigation: AdminNavigationItem[] = [
  {
    segment: adminNavigationPaths.users,
    title: 'Users',
    icon: <People />,
    pattern: 'users{/:userId}*'
  },
  {
    segment: adminNavigationPaths.offerRequests,
    title: 'Offer Requests',
    icon: <ShoppingCart />,
    pattern: 'offer-requests{/:userId}*'
  },
  {
    segment: adminNavigationPaths.fulfillmentOrders,
    title: 'Fulfillment Orders',
    icon: <LocalShipping />,
    pattern: 'fulfillment-orders{/:orderId}*'
  },
  {
    segment: adminNavigationPaths.readyToPurchase,
    title: 'Ready to Purchase',
    icon: <ShoppingBasket />
  },
  {
    segment: adminNavigationPaths.trips,
    title: 'Trips',
    icon: <FlightTakeoff />,
    pattern: 'trips{/:userId}*'
  },
  {
    segment: adminNavigationPaths.externalBookings,
    title: 'External Bookings',
    icon: <CalendarMonth />
  },
  {
    segment: adminNavigationPaths.discountCodes,
    title: 'Discount Codes',
    icon: <LocalOffer />
  },
  {
    segment: adminNavigationPaths.lockers,
    title: 'Lockers',
    icon: <Lock />
  },
  {
    segment: adminNavigationPaths.lockerOrders,
    title: 'Locker Orders',
    icon: <Inventory2 />
  }
]
